module.exports = __webpack_public_path__ + "img/linkedin.e7a6ccc2.svg";